import React from 'react'
import { Accordion, Badge } from '@platform/ui'
import styles from './CourseFilterAccordion.module.scss'

type Props = {
  title: string
  badgeCount: number
  children: React.ReactNode | React.ReactNode[]
  testId?: string
}

export const CourseFilterAccordion = ({ title, badgeCount, children, testId }: Props) => {
  return (
    <div className={styles.container}>
      <Accordion
        title={
          <div className={styles.rowGap8}>
            <div className={styles.title}>{title}</div>
            <Badge>{badgeCount}</Badge>
          </div>
        }
        hasBottomBorder={false}
        hasTopBorder={false}
        testId={testId}
      >
        <div className={styles.columnGap12}>{children}</div>
      </Accordion>
    </div>
  )
}
